import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { dayjs } from "@arco-design/web-vue/es/_utils/date";
import { getAppAnswerVoByIdUsingGet } from "@/api/appAnswerController";

interface Props {
  id: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppResultPage',
  props: {
    id: { default: () => {
    return "";
  } }
  },
  setup(__props: any) {

const props = __props;

const data = ref<API.AppanswerVO>({});
const isPic = ref(false);
/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.id) {
    return;
  }
  const res = await getAppAnswerVoByIdUsingGet({
    id: props.id as any,
  });
  if (res.data.code === 200) {
    data.value = res.data.data as any;
    if (data.value.resultPic) {
      isPic.value = true;
    }
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "appResultPage" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            span: isPic.value ? 12 : 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_typography_title, { heading: 3 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.value.appName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions, {
                size: "large",
                column: 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_descriptions_item, { label: "结果名称" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.value.resultName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_descriptions_item, { label: "结果描述" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.value.resultDesc), 1)
                    ]),
                    _: 1
                  }),
                  (data.value.resultScore)
                    ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                        key: 0,
                        label: "结果得分"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.value.resultScore), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_descriptions_item, { label: "答题时间" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(dayjs)(data.value.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_space, { class: "bottomBtn" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "outline",
                    href: `/app/detail/${data.value.appId}`,
                    style: {"width":"150px","height":"50px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("返回题目 ")
                    ]),
                    _: 1
                  }, 8, ["href"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    href: "/app",
                    style: {"width":"150px","height":"50px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("返回答题应用页 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    type: "outline",
                    href: `/app/answer/${data.value.appId}`,
                    style: {"width":"150px","height":"50px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("再次答题 ")
                    ]),
                    _: 1
                  }, 8, ["href"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["span"]),
          (isPic.value)
            ? (_openBlock(), _createBlock(_component_a_col, {
                key: 0,
                span: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_image, {
                    width: "100%",
                    src: data.value.resultPic,
                    alt: "结果图片"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})